// import ContainerDefault from "../../Componant/Dashboard/Default/Default";

const Dashboard = () => {
  return <div className="page-body">{/* <ContainerDefault /> */}</div>;
};

export default Dashboard;
